
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    labels: {
      type: Array,
      default: new Array()
    },
    modelValue: {
      type: Map,
      default: new Map()
    }
  },
  data() {
    return {
      selectAll: 1,
      selectAllText: ['Select All', 'Unselect All']
    }
  },
  mounted() {
    // Set the default value to be true once mounted
    for (let key of this.labels) {
      this.modelValue.set(key, true)
    }
  },
  methods: {
    updateSelected(newSelect: string) {
      this.modelValue.set(newSelect, !this.modelValue.get(newSelect))
      this.$emit('update:modelValue', this.modelValue)
    },
    revertAllSelection() {
      this.selectAll = 1 - this.selectAll
      for (let key of this.modelValue.keys()) {
        this.modelValue.set(key, Boolean(this.selectAll))
      }
    }
  }
})
